module.exports = __webpack_public_path__ + "static/media/Mars_Perseverance.55471e0b.png";